import i18n from 'modules/core/lib/i18n'

import { validateEmailForCreation } from 'modules/employees/lib/validateEmailForCreation'

type Props = {
  email: string
}

const validateEmail = ({ email }: Props) => {
  const { valid, errorString } = validateEmailForCreation(email)

  return {
    isValid: valid,
    message: errorString ?? i18n.t('importer_process.edition_step.validators.email'),
  }
}

export default validateEmail
